import { isNil, omitBy } from 'lodash-es'

import { rootApi } from 'root-api'

const api = rootApi.injectEndpoints({
  endpoints: (build) => ({
    eventTypeFiltersFetchOrganizationMemberships: build.query({
      query: ({ filterTerm, membershipIds, groupId } = {}) => ({
        url: '/api/organization/memberships',
        method: 'GET',
        params: omitBy({ filterTerm, membershipIds, userGroupId: groupId }, isNil)
      }),
    }),
  }),
})

export const { useEventTypeFiltersFetchOrganizationMembershipsQuery: useFetchOrganizationMembershipsQuery } = api
